import React, { useCallback, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../api/client';

const save = async (url, name) => {
  const res = await api.get(url, { responseType: 'blob' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(res.data);
  a.download = name;
  a.click();
};

const AdminAllotment = () => {
  const { id } = useParams();
  const [commitments, setCommitments] = useState(null);
  const [register, setRegister] = useState(null);

  const load = useCallback(async () => {
    try {
      const [c, r] = await Promise.all([api.get('/api/admin/commitments/', { params: { spv: id } }), api.get(`/api/admin/spvs/${id}/register/`)]);
      setCommitments(c.data); setRegister(r.data);
    } catch (e) {
      toast.error('Failed to load');
    }
  }, [id]);
  useEffect(() => { load(); }, [load]);

  const allot = async () => {
    const ready = commitments.filter((c) => c.status === 'docs_signed').length;
    if (!window.confirm(`Allot shares for ${ready} signed commitment(s)? This cannot be undone.`)) return;
    try {
      const res = await api.post(`/api/admin/spvs/${id}/allot/`, {});
      toast.success(`Allotted ${res.data.allotted.length} commitment(s)`);
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Allotment failed');
    }
  };
  const pas3 = async (row) => {
    const d = window.prompt('PAS-3 filed on (YYYY-MM-DD), blank to clear:', row.pas3_filed_on || '');
    if (d === null) return;
    const sh = register.rows.find((r) => r.certificate_no === row.certificate_no);
    try { await api.patch(`/api/admin/shareholdings/${sh.shareholding_id}/`, { pas3_filed_on: d || null }); load(); } catch (e) { toast.error('Invalid date'); }
  };

  if (!commitments) return <main style={{ padding: '4rem 1rem', textAlign: 'center' }}><p>Loading…</p></main>;
  const count = (s) => commitments.filter((c) => c.status === s).length;
  return (
    <main style={{ maxWidth: 1000, margin: '0 auto', padding: '2rem 1rem' }}>
      <p><Link to={`/admin/spvs/${id}`}>← SPV</Link></p>
      <h1>Allotment and register of members</h1>
      <p>Paid: {count('paid')} · Documents signed: {count('docs_signed')} · Allotted: {count('allotted')}</p>
      <button onClick={allot} disabled={count('docs_signed') === 0}>Allot all signed commitments</button>

      <h2>Register of members</h2>
      <p>{register.totals.members} members · {register.totals.total_shares_allotted} shares allotted</p>
      <button onClick={() => save(`/api/admin/spvs/${id}/register/?export=csv`, 'register-of-members.csv')}>Export CSV</button>{' '}
      <button onClick={() => save(`/api/admin/spvs/${id}/register/?export=pdf`, 'register-of-members.pdf')}>Export PDF</button>
      <table>
        <thead><tr><th>Folio</th><th>Member</th><th>Shares</th><th>% holding</th><th>Certificate</th><th>Allotted</th><th>PAS-3</th></tr></thead>
        <tbody>{register.rows.map((r) => (
          <tr key={r.certificate_no}><td>{r.folio}</td><td>{r.member}</td><td>{r.shares}</td><td>{Number(r.holding_pct).toFixed(2)}%</td><td>{r.certificate_no}</td><td>{r.allotted_on}</td>
            <td>{r.pas3_filed_on || '-'} <button onClick={() => pas3(r)}>Set</button></td></tr>
        ))}</tbody>
      </table>
    </main>
  );
};

export default AdminAllotment;
